import React, { FC } from 'react';
import { FormControl as BaseFormControl, FormControlProps, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react/macro';

interface Props {
  error?: boolean;
}

const invalidStyles = css`
  & [aria-invalid],
  & .react-select-field > div {
    box-shadow: none !important;
  }
  & > label {
    opacity: 0.75;
    font-weight: 500;
  }
`;

const StyledFormControl = styled(BaseFormControl)`
  position: relative;
  width: 100%;
`;

const FormControl: FC<FormControlProps & Props> = ({ children, error, ...props }) => {
  const { colors } = useTheme();
  return (
    <StyledFormControl
      css={error && invalidStyles}
      isInvalid={error}
      sx={
        error
          ? {
              '& [aria-invalid], & .react-select-field > div': { border: `2px solid ${colors.pink[500]} !important` },
              '& > label': { color: 'pink.500' },
            }
          : undefined
      }
      {...props}
    >
      {children}
    </StyledFormControl>
  );
};

export default FormControl;
